module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 5-af016a4d6264743823d676a17a6e135d.jpg";